module.exports = __webpack_public_path__ + "img/2.285e742e.png";